export type InAppBrowser =
  | 'facebook'
  | 'instagram'
  | 'line'
  | 'linkedin'
  | 'messenger'
  | 'pinterest'
  | 'snapchat'
  | 'threads'
  | 'tiktok'
  | 'wechat'
  | 'x';

const IN_APP_BROWSER_PATTERNS: Array<[InAppBrowser, RegExp]> = [
  ['instagram', /\bInstagram\b/],
  ['threads', /\bBarcelona \d/],
  ['messenger', /\bFBAN\/Messenger|\bFB_IAB\/(?:MESSENGER|Orca-Android)/i],
  ['facebook', /\bFBAN\/|\bFBAV\/|\bFB_IAB\/|\bFBIOS\b|\bFB4A\b|\bMetaIAB\b/],
  ['tiktok', /\bmusical_ly|\bBytedance|\bTikTok\b|\btrill_\d|\bAppName\/trill\b/i],
  ['linkedin', /\bLinkedInApp\b/],
  ['snapchat', /\bSnapchat\b/],
  ['pinterest', /\bPinterest\b/],
  ['x', /\bTwitterAndroid\b/],
  ['line', /\bLine\/\d/],
  ['wechat', /\bMicroMessenger\b/],
];

export const getInAppBrowser = (userAgent = navigator.userAgent): InAppBrowser | null =>
  IN_APP_BROWSER_PATTERNS.find(([, pattern]) => pattern.test(userAgent))?.[0] ?? null;
